import { LIST_SURGE_RULES, LIST_SURGE_RULES_SUCCESS, LIST_SURGE_RULES_ERROR, LIST_SURGE_RULES_EMPTY } from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetSurgeRulesList = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SURGE_RULES:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case LIST_SURGE_RULES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case LIST_SURGE_RULES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case LIST_SURGE_RULES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetSurgeRulesList;
